<template>
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'1250px'"
    :classDialog="'dialogTransferHandling'"
    :offsetTop="'8vh'"
    :appendToBody="true"
    :modalAppendToBody="true"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <div class="title flex-row">
        <h2 class="dialogTitle">
          Chuyển xử lý văn bản đến
        </h2>
        &nbsp;&nbsp;
        <div class="title-content">
          <el-tag class="priority lv3">
            {{ quote }}
          </el-tag>
        </div>
      </div>
      <!-- body -->
      <el-row class="dialog-body margin-0" :gutter="24">
        <el-col :span="24" class="list-collapse__transfer">
          <div class="">
            <div class="font-size__large font-weight__bold margin-top-10">Danh sách Lãnh đạo sơ duyệt văn bản:</div>
            <VuePerfectScrollbar class="scroll-area scroll-area-height_90">
              <el-tree
                v-loading="isLoadingRoots1"
                :data="roots1"
                :filter-node-method="filterTree"
                ref="departmentTree"
                class="filter-tree"
                default-expand-all
              >
                <div
                  class="custom-tree-node flex-row flex__between width__100"
                  slot-scope="{ node, data }"
                >
                  <div v-if="isChoDuyetCxl" class="field-1">
                    <span v-if="data.isHandlerNode">
                      <el-radio
                        v-model="selectedHandlerId"
                        :label="data.userDeptRole ? data.userDeptRole.id : data.department.id"
                        @change="checkedChangeEvent(data)"
                      >
                        <span
                          v-if="
                          data.nodeType ===
                            DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
                        "
                        >
                          <span class="font-weight__bold">{{ data.userDeptRole.fullName }}</span>

                          <span class="font-size__small font-italic">({{ data.userDeptRole.positionName }})</span>
                            <span style="position: relative">
                              <el-tooltip
                                v-if="data.userDeptRole.absentCount&&data.userDeptRole.absentCount!=0"
                                :content="tooltipContent(data.userDeptRole)"
                                placement="right"
                                effect="dark">
                                <absent-notify></absent-notify>
                              </el-tooltip>
                            </span>
                          </span>
                        <span v-else>&nbsp;{{ getNodeLabel(data) }}</span>
                      </el-radio>
                    </span>
                    <span v-else>
                      <span v-if="data.nodeType === DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE">
                        <span class="font-weight__bold">{{ data.userDeptRole.fullName }}</span>
                        <span class="font-size__small font-italic">({{ data.userDeptRole.positionName }})</span>
                          <span style="position: relative">
                            <el-tooltip
                              v-if="data.userDeptRole.absentCount&&data.userDeptRole.absentCount!=0"
                              :content="tooltipContent(data.userDeptRole)"
                              placement="right"
                              effect="dark">
                              <absent-notify></absent-notify>
                            </el-tooltip>
                          </span>
                        </span>
                      <span v-else>&nbsp;{{ getNodeLabel(data) }}</span>
                    </span>
                  </div>
                </div>
              </el-tree>
            </VuePerfectScrollbar>
          </div>
          <div class="margin-top-15">
            <so-duyet-tree-group
              :stepId="stepId"
              ref="soDuyetTreeGroup"
            />
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="history-action">

            <div id="detail-footer" class="panel-footer" v-if="isEnableComment= true">
              <div ref="commentArea" :class="['active', 'input-comment']">
                <!-- commentInput: -->
                <div>
                  <transition name="el-fade-in-linear">
                    <el-input
                      type="textarea"
                      resize="none"
                      ref="inputComment"
                      :rows="3"
                      placeholder="Kính trình"
                      v-model="content"
                      class="text-input-comment"
                    ></el-input>
                  </transition>
                </div>
                <!-- commentInput:end -->
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button
          class="dialogBtnPrimary"
          @click="submit"
          :disabled="isProcessing"
        >
          <i
            :class="[
              !isProcessing
                ? 'fas fa-check-circle font-size__small'
                : 'el-icon-loading'
            ]"
          ></i>
          &nbsp;Xác nhận
        </el-button>
        <el-button
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >
          <i class="fal fa-times"></i>
          &nbsp;Hủy
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import buildShortNameFilter from "../../../filters/buildShortNameFilter.js";
import constants from "../../../constants";
import nextStepInfoViewService from "../../../services/nextStepInfoViewService";
import h from "../../../services/h";
import cxlVbdenCommonMixin from "../../../mixins/cxlVbdenCommonMixin";
import AbsentNotify from "../../common/absents/absent-notify";
import dateFormatter from "../../../filters/dateFormatter";
import SoDuyetTreeGroup from "./so-duyet-tree-group.vue"

export default {
  name: "cxl-vbden-cho-cxl-ld-n",
  mixins: [cxlVbdenCommonMixin],
  filters: {buildShortNameFilter},
  props: [
    "flowId",
    "stepId",
    "flag",
    "docId",
    "isOpen",
    "quote",
    "incomingProcessId",
    "nextVbIncomingProcess",
    "note",
    "isProcessing",
    "defaultProcessType"
  ],

  components: {
    AbsentNotify,
    dialogTemplate: () => import("../../common/custom-dialog.vue"),
    chuyenXuLyHashtag: () => import("./chuyenXuLy-hashtag-soduyet-cxl"),
    SoDuyetTreeGroup,
    VuePerfectScrollbar
  },

  data() {
    return {
      activeTabName: 'firstTab',
      roots1: [],
      isLoadingRoots1: true,
      selectedHandlers: [],
      selectedHandlerId: null,
      content: null,
    }
  },

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
    isLanhDao() {
      return (
        this.userDeptRole &&
        this.userDeptRole.roleCode === constants.ROLE.CODE.LANH_DAO
      );
    },
    isNhanhDang() {
      return (
        this.userDeptRole &&
        this.userDeptRole.deptPath.includes('/TCT/DU', 0)
      );
    },
    isChoDuyetCxl() {
      return this.flag === constants.STEP.FLAG_CHO_DUYET_CXL;
    },
    isDuyetCxl() {
      return this.flag === constants.STEP.FLAG_DUYET_CXL;
    }
  },

  created() {
    this.initForm();
  },

  methods: {
    tooltipContent(item){
      return `Vắng mặt từ `+dateFormatter(item.absentStartTime)+` đến `+dateFormatter(item.absentDeadlineTime);
    },

    checkedChangeEvent(data) {
      if (data.isHandlerNode) {
        this.selectedHandlersData = [];
        let nodeType = data.nodeType;
        switch (nodeType) {
          case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
          case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
            this.selectedHandlersData.push({
              data: data,
              processType: constants.PROCESS_TYPE.CHUTRI
            });
            break;
          default:
            break;
        }
      }
    },

    async initForm() {
      this.form.note = this.note;
      await this.buidNodesCXLList();
    },

    // Load va build node danh sach chuyen xu ly
    buidNodesCXLList() {
      if(this.roots1.length !== 0) return;
      return this.loadNextStepsInfo(this.flowId, this.stepId)
        .then(nextSteps => {
          this.nextSteps = nextSteps;
          return this.loadHandlers(this.stepId, nextSteps);
        })
        .then(results => {
          let userDeptRolesSet = results[0];
          let departments = results[1];
          this.userDeptRoleHandlers = userDeptRolesSet;
          this.departmentHandlers = departments;
          this.filterAllAlreadyForwardedHandlers();
          return this.buildNodes().then(() => {
            this.roots1 = [...this.roots];
            h.each(this.roots1, root =>
              this.markCheckedForSelectedHandlers(root, '1')
            );
            this.refreshProcessType();
            this.isLoadingRoots1 = false;
          });
        });
    },

    loadNextStepsInfo(flowId, stepId) {
      return nextStepInfoViewService
        .nextSteps(flowId, stepId)
        .then(response => response.data);
    },

    markCheckedForSelectedHandlers(data, flag) {
      h.each(data.children, child =>
        this.markCheckedForSelectedHandlers(child, flag)
      );

      let selectedHandler;
      let nodeType = data.nodeType;
      switch (nodeType) {
        case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
          let department = data.department;
          selectedHandler = h.find(
            this.selectedHandlers,
            item =>
              item.stepType === constants.STEP.STEP_TYPE.DONVI &&
              department.id === item.department.id
          );
          break;
        case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
          let userDeptRole = data.userDeptRole;
          selectedHandler = h.find(
            this.selectedHandlers,
            item =>
              item.stepType === constants.STEP.STEP_TYPE.CANHAN &&
              userDeptRole.id === item.userDeptRole.id
          );
          break;
        default:
          break;
      }

      if (selectedHandler) {
        if (data.isHandlerNode) {
          this.$set(data, "checked", true);
          if (flag == '1') {
            this.addOrRemoveToSelectedHandlers(data, selectedHandler.processType);
          } else {
            this.addOrRemoveToSelectedHandlers2(data, selectedHandler.processType);
          }
        } else {

          if (!data.checked) {
            this.$set(data, "checked", true);
            h.each(data.children, child => {
              this.$set(child, "checked", true);
              if (flag == '1') {
                this.addOrRemoveToSelectedHandlers(child, selectedHandler.processType);
              } else {
                this.addOrRemoveToSelectedHandlers2(child, selectedHandler.processType);
              }
            });
          }
        }
      } else if(!data.isHandlerNode) {
        let isAllChildNodesChecked = !h.exists(
          data.children,
          child => !child.checked
        );
        this.$set(data, "checked", isAllChildNodesChecked);
      }
    },

    filterAllAlreadyForwardedHandlers() {
      this.userDeptRoleHandlers = h.findAll(
        this.userDeptRoleHandlers,
        userDeptRole =>
          h.indexOf(
            this.nextVbIncomingProcess,
            process =>
              process.stepType === constants.STEP.STEP_TYPE.CANHAN &&
              (process.receiverUserDeptRoleId === userDeptRole.id ||
                (process.receiverId === userDeptRole.userId &&
                  process.deptReceiverId === userDeptRole.deptId &&
                  process.roleReceiverId === userDeptRole.roleId))
          ) === -1
      );

      this.departmentHandlers = h.findAll(
        this.departmentHandlers,
        department =>
          h.indexOf(
            this.nextVbIncomingProcess,
            process =>
              process.stepType === constants.STEP.STEP_TYPE.DONVI &&
              process.deptReceiverId === department.id
          ) === -1
      );
    },

    submit() {
      if (!this.validate()) return;

      const handlersData = this.processSelectedHandlerData(this.selectedHandlersData);

      this.selectedHandlersData2 = this.$refs.soDuyetTreeGroup.getSelectedHandlersData();
      const handlersData2 = this.processSelectedHandlerData(this.selectedHandlersData2);

      let submitComment = this.content? this.content : 'Kính trình';
      this.$emit("submit",
        {
          handlersData: handlersData,
          note: submitComment,
          isAutoAssignTask: this.form.isAutoAssignTask,
          handlersData2: handlersData2
        }
      );
    },

    processSelectedHandlerData(selectedHandlersData) {
      let handlersData = [];
      selectedHandlersData
        .filter(
          item =>
            item.data.nodeType ===
            constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
        )
        .forEach(item => {
          handlersData.push({
            userDeptRole: item.data.userDeptRole,
            processType: item.processType,
            stepId: this.findStepIdForHandler(
              item.data,
              this.stepId,
              this.nextSteps
            ),
            stepType: constants.STEP.STEP_TYPE.CANHAN
          });
        });

      selectedHandlersData
        .filter(
          item =>
            item.data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT
        )
        .map(item => {
          handlersData.push({
            department: item.data.department,
            processType: item.processType,
            stepId: this.findStepIdForHandler(
              item.data,
              this.stepId,
              this.nextSteps
            ),
            stepType: constants.STEP.STEP_TYPE.DONVI
          });
        });
      return handlersData;
    }
  }
};
</script>
<style scoped>
.title {
  width: 100%;
}

.list-checkbox {
  position: relative;
  margin-right: 10px;
}

.scroll-list-user {
  height: auto;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  margin: auto;
}

.list-checkbox .item {
  width: 90px;
  text-align: center;
  margin: 0;
}

.icon-close {
  position: absolute;
  right: -5px;
  font-size: 18px;
}

.dialog-body .display-list__selected .list-selected .header > div {
  width: 100%;
}

.dialog-body .display-list__selected .list-selected .body {
  padding: 0;
}

.dialogTransferHandling .dialog-body .list-collapse__transfer {
  display: flex;
  flex-direction: column;
}

.dialogTransferHandling .dialog-body .scroll-area-height_90 {
  height: 100%;
  margin-bottom: 0;
  margin-right: -13px;
}

.dialog-body .display-list__selected {
  height: 400px;
}

.dialogTransferHandling .dialog-body .display-list__selected .list-selected {
  height: calc(100% - 121px);
}

.dialogTransferHandling
.dialog-body
.display-list__selected
.list-selected.withAutoAssignTask {
  height: calc(100% - 145px) !important;
}

.dialog-body .display-list__selected .list-selected .header {
  padding-left: 10px;
  padding-right: 10px;
}

.dialog-body .display-list__selected .list-selected .body .list-filter {
  height: 100%;
}

/*.dialogTransferHandling .dialog-body .list-collapse__transfer {*/
/*  height: 405px;*/
/*}*/

.dialog-body {
  height: 65vh !important;
}

.list-collapse__transfer {
  height: 100% !important;
}

</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/cxl-vbden-cho-cxl-ld-n.vue